export const GET_LANDS_LIST = "get_land";
export const CREATE_LAND = "create_land";
export const EDIT_LAND = "edit_land";
export const START_LOADING = "start_loading";
export const DELETE_LAND = "delete_land";
export const STOP_LOADING = "stop_loading";
export const LAND_ERROR = "land_error";
export const ACCESS_RIGHT_ERROR = "access_error";
